import React, { useCallback, memo } from "react";
import PropTypes from "prop-types";
import { getImageSrcFromItem, isPdfItem } from "../utils";

function ImageThumbnail({
  item,
  index,
  totalCount,
  onSelect,
  onRemove,
  stackSize = false,
  displayPage,
}) {
  const imageSrc = getImageSrcFromItem(item);
  const pageLabel = displayPage != null ? displayPage : index + 1;
  const handleClick = useCallback(() => onSelect(index), [index, onSelect]);
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect(index);
      }
    },
    [index, onSelect]
  );
  const handleRemove = useCallback(
    (e) => {
      e.stopPropagation();
      onRemove(index);
    },
    [index, onRemove]
  );
  return (
    <div
      role="button"
      tabIndex={0}
      className="w-[55px] h-[60px] group relative flex-shrink-0 rounded-lg cursor-pointer bg-neutral-800 border border-white/20 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-black transition-all"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <div
        className={`relative w-full h-full rounded-lg overflow-hidden ${stackSize ? "bg-neutral-100" : ""}`}
      >
        {isPdfItem(item) ? (
          <div className="w-full h-full flex items-center justify-center text-neutral-600 text-xs font-semibold">
            PDF
          </div>
        ) : (
          <img src={imageSrc} className="w-full h-full object-cover" alt="" loading="lazy" />
        )}
      </div>
      <span
        className="absolute bottom-0 left-0 right-0 py-0.5 text-center text-[10px] font-medium bg-black/50 text-white/95 rounded-b-lg"
        aria-hidden
      >
        {pageLabel} / {totalCount}
      </span>
      <button
        type="button"
        className="absolute z-20 -top-2 -right-2 w-5 h-5 rounded-full bg-black/50 text-white flex items-center justify-center text-sm leading-none shadow-lg hover:bg-black hover:scale-105 transition-all"
        onClick={handleRemove}
        aria-label={`Remove page ${pageLabel}`}
      >
        ×
      </button>
    </div>
  );
}

ImageThumbnail.propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  index: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  stackSize: PropTypes.bool,
  displayPage: PropTypes.number,
};

export default memo(ImageThumbnail);
